<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	name: 'Full Name',
	title: 'Title',
	image: '/webclip.png',
	showImage: true,
}
const schema = defineSchema({
	name: $.text('Name'),
	title: $.text('Title'),
	image: $.upload('Image'),
	showImage: $.toggle('Show Image'),
})
export const AuthorSmallLink = defineBlock({ pickerHidden: true, thumbnail: '/block-thumbs/AuthorSmallLink.svg', category: 'Listings', order: 70, name: 'AuthorSmallLink', label: 'Author Small Link', icon: 'badge', schema, defaults })
</script>
<script setup lang="ts">

import { Image } from '@bagelink/vue'
import { computed } from 'vue'




const props = defineProps<{
	title?: string
	name?: string
	image?: string
	showImage?: boolean
	link?: string
	author?: {
		name: string
		title: string
		image: string
		bio?: string
		slug?: string
		link?: string
	}
}>()

// Computed values that work with both patterns
const authorName = computed(() => props.author?.name || props.name || 'Full Name')
// No `'Title'` fallback: a record without an honorific must render the bare name
// rather than the literal placeholder word next to it.
const authorTitle = computed(() => props.author?.title || props.title || '')
const authorImage = computed(() => props.author?.image || props.image || '/webclip.png')
const authorSlug = computed(() => props.author?.slug || '')
const authorLink = computed(() => props.author?.link || props.link || (authorSlug.value ? `/author/${authorSlug.value}` : '/authors'))
const shouldShowImage = computed(() => props.showImage !== false)
</script>

<template>
	<router-link
		:to="authorLink"
		class="inline-flex me-05 gap-05 color-gray-70 align-items-center decoration-none"
	>
		<Image
			v-if="shouldShowImage"
			:src="authorImage"
			:alt="authorName"
			ratio="1"
			class="w30px h30px cover round flex-shrink-0 flex-grow-0"
		/>
		<i class="light flex-shrink-0 flex-grow-0 ellipsis">
			{{ authorTitle }}
			{{ authorName }}
		</i>
	</router-link>
</template>

<style>

</style>
